import {UserManager} from 'oidc-client-ts';
import {ReactNode, useCallback} from 'react';
import type {User as Auth0User} from "@auth0/auth0-react";
import {useAuth0} from "@auth0/auth0-react";

type Props = {
    userManager : UserManager;
    children ?: ReactNode;
};

export type OidcUser = {
    accessToken : string;
    sub : string;
    name ?: string;
};


export const useUser = () : Auth0User | undefined => {
    const user = useAuth0();
    //
    // if (!user) {
    //     throw new Error('Context was used before initial load');
    // }

    return user.user;
};

if (!process.env.REACT_APP_API_ENDPOINT) {
    throw new Error('REACT_APP_API_ENDPOINT not defined');
}

export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
type ApiFetch = (url : string, init ?: RequestInit) => Promise<Response>;

export const useApiFetch = () : ApiFetch => {
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    const getToken = async () => {
        if (!isAuthenticated) return null;
        // When useRefreshTokens is enabled, the SDK first tries refresh flow,
        // and falls back to silent auth (if enabled) before throwing.
        // Prefer detailedResponse if you need expires_in, scope, etc.
        const { access_token } = await getAccessTokenSilently({ detailedResponse: true });
        return access_token;
    };


    return useCallback(async (url : string, init ?: RequestInit) : Promise<Response> => {
        if (!init) {
            init = {};
        }

        init.headers = init.headers instanceof Headers ? init.headers : new Headers(init.headers);
        init.headers.append('Authorization', `Bearer ${await getToken()}`);
        init.headers.append('Content-Type', 'application/json');

        return fetch(url, init);
    }, [isAuthenticated, getAccessTokenSilently]);
};
